module.exports = __webpack_public_path__ + "img/color_block_2.ea4e43d9.svg";